import MUIGrid from "@mui/material/Grid2";
import MUIPaper from "@mui/material/Paper";
import MUIList from "@mui/material/List";
import MUIListItemText from "@mui/material/ListItemText";
import MUIButton from "@mui/material/Button";
import MUIListItemButton from "@mui/material/ListItemButton";
import MUIListSubheader from "@mui/material/ListSubheader";

import MUIKeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import MUIKeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import MUIKeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import MUIKeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import MUIKeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import MUIKeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import MUIKeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MUIKeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import UploadedFile from "../Utility/Crud/UploadedFile";

export default function CompletedPaperworkTransferList(props) {
  const leftItemChecked =
    props.checkedItem && props.leftItems.includes(props.checkedItem)
      ? [props.checkedItem]
      : [];
  const rightItemChecked =
    props.checkedItem && props.rightItems.includes(props.checkedItem)
      ? [props.checkedItem]
      : [];

  /**
   * Moves all items from left to right.
   */
  const handleAllRight = () => {
    props.setRightItems(props.rightItems.concat(props.leftItems));
    props.setLeftItems([]);
    props.setCheckedItem(null);
  };

  /**
   * Moves all checked items from left to right.
   */
  const handleCheckedRight = () => {
    if (leftItemChecked.length === 0) {
      return;
    }
    props.setRightItems(props.rightItems.concat(leftItemChecked));
    props.setLeftItems(
      props.leftItems.filter((value) => !leftItemChecked.includes(value)),
    );
    props.setCheckedItem(null);
  };

  /**
   * Moves all checked items from right to left.
   */
  const handleCheckedLeft = () => {
    if (rightItemChecked.length === 0) {
      return;
    }
    props.setLeftItems(props.leftItems.concat(rightItemChecked));
    props.setRightItems(
      props.rightItems.filter((value) => !rightItemChecked.includes(value)),
    );
    props.setCheckedItem(null);
  };

  /**
   * Moves all items from right to left.
   */
  const handleAllLeft = () => {
    props.setLeftItems(
      UploadedFile.sort(props.leftItems.concat(props.rightItems)),
    );
    props.setRightItems([]);
    props.setCheckedItem(null);
  };

  /**
   * Moves the checked item in the right list to the very top.
   */
  const handleTop = () => {
    if (rightItemChecked.length === 0) {
      return;
    }
    const item = rightItemChecked[0];
    const remainingItems = props.rightItems.filter((i) => i !== item);
    props.setRightItems([item, ...remainingItems]);
  };

  /**
   * Moves the checked item in the right list to the very top.
   */
  const handleUp = () => {
    if (rightItemChecked.length === 0) {
      return;
    }
    const item = rightItemChecked[0];
    const currentIndex = props.rightItems.indexOf(item);

    if (currentIndex <= 0) {
      return; // Already at top or not found
    }

    const newItems = [...props.rightItems];
    newItems.splice(currentIndex, 1);
    newItems.splice(currentIndex - 1, 0, item);
    props.setRightItems(newItems);
  };

  /**
   * Moves the checked item in the right list down one position.
   */
  const handleDown = () => {
    if (rightItemChecked.length === 0) {
      return;
    }
    const item = rightItemChecked[0];
    const currentIndex = props.rightItems.indexOf(item);

    if (currentIndex === -1 || currentIndex >= props.rightItems.length - 1)
      return; // Not found or already at bottom

    const newItems = [...props.rightItems];
    newItems.splice(currentIndex, 1);
    newItems.splice(currentIndex + 1, 0, item);
    props.setRightItems(newItems);
  };

  /**
   * Moves the checked item in the right list to the very bottom.
   */
  const handleBottom = () => {
    if (rightItemChecked.length === 0) {
      return;
    }
    const item = rightItemChecked[0];
    const remainingItems = props.rightItems.filter((i) => i !== item);
    props.setRightItems([...remainingItems, item]);
  };

  /**
   * Toggles the checked state of an item.
   * @param {Object} value - The item to toggle.
   * @returns {Function} A function that toggles the checked state of the item.
   */
  const handleToggle = (value) => () => {
    if (props.checkedItem === value) {
      props.setCheckedItem(null);
    } else {
      props.setCheckedItem(value);
    }
  };

  /**
   * Renders a list box of items.
   * @param {Array} items - The items to render.
   * @returns {JSX.Element} The list box of items.
   */
  const TransferListBox = ({ items, side }) => {
    const subheader =
      side === "left" ? "Available Documents" : "Selected Documents";
    return (
      <MUIPaper
        elevation={0}
        sx={{
          height: 230,
          overflow: "auto",
          border: (theme) => `1px solid ${theme.palette.text.disabled}`,
          backgroundColor: (theme) => theme.palette.background.paper,
        }}
      >
        <MUIList
          dense
          component="div"
          role="list"
          subheader={
            <MUIListSubheader sx={{ px: 1 }}>{subheader}</MUIListSubheader>
          }
        >
          {items?.length > 0 &&
            items?.map((item) => (
              <MUIListItemButton
                key={item.id}
                role="listitem"
                onClick={handleToggle(item)}
                selected={props.checkedItem === item}
                sx={{
                  py: 0,
                  px: 1,
                  "&:hover": {
                    backgroundColor: (theme) => theme.palette.background.hover,
                  },
                  "&.Mui-selected": {
                    backgroundColor: (theme) => theme.palette.background.hover,
                    "&:hover": {
                      backgroundColor: (theme) =>
                        theme.palette.background.hover,
                    },
                  },
                }}
              >
                <MUIListItemText primary={item.filename} />
              </MUIListItemButton>
            ))}
        </MUIList>
      </MUIPaper>
    );
  };

  return (
    <MUIGrid container spacing={0} rowSpacing={3} sx={{ alignItems: "center" }}>
      <MUIGrid
        size={{
          lg: 5,
          xs: 10,
        }}
      >
        <TransferListBox items={props.leftItems} side="left" />
      </MUIGrid>
      <MUIGrid size={1}>
        <MUIGrid
          container
          direction="column"
          spacing={1}
          sx={{ alignItems: "center" }}
        >
          <MUIGrid size={12}>
            <MUIButton
              variant="outlined"
              size="small"
              onClick={handleAllRight}
              sx={{ minWidth: "auto", aspectRatio: "1/1" }}
            >
              <MUIKeyboardDoubleArrowRightIcon fontSize="small" />
            </MUIButton>
          </MUIGrid>
          <MUIGrid size={12}>
            <MUIButton
              variant="outlined"
              size="small"
              onClick={handleCheckedRight}
              sx={{ minWidth: "auto", aspectRatio: "1/1" }}
            >
              <MUIKeyboardArrowRightIcon fontSize="small" />
            </MUIButton>
          </MUIGrid>
          <MUIGrid size={12}>
            <MUIButton
              variant="outlined"
              size="small"
              onClick={handleCheckedLeft}
              sx={{ minWidth: "auto", aspectRatio: "1/1" }}
            >
              <MUIKeyboardArrowLeftIcon fontSize="small" />
            </MUIButton>
          </MUIGrid>
          <MUIGrid size={12}>
            <MUIButton
              variant="outlined"
              size="small"
              onClick={handleAllLeft}
              sx={{ minWidth: "auto", aspectRatio: "1/1" }}
            >
              <MUIKeyboardDoubleArrowLeftIcon fontSize="small" />
            </MUIButton>
          </MUIGrid>
        </MUIGrid>
      </MUIGrid>
      <MUIGrid
        size={{
          lg: 5,
          xs: 10,
        }}
      >
        <TransferListBox items={props.rightItems} side="right" />
      </MUIGrid>
      <MUIGrid size={1}>
        <MUIGrid
          container
          direction="column"
          spacing={1}
          sx={{ alignItems: "center" }}
        >
          <MUIGrid size={12}>
            <MUIButton
              variant="outlined"
              size="small"
              onClick={handleTop}
              sx={{ minWidth: "auto", aspectRatio: "1/1" }}
            >
              <MUIKeyboardDoubleArrowUpIcon fontSize="small" />
            </MUIButton>
          </MUIGrid>
          <MUIGrid size={12}>
            <MUIButton
              variant="outlined"
              size="small"
              onClick={handleUp}
              sx={{ minWidth: "auto", aspectRatio: "1/1" }}
            >
              <MUIKeyboardArrowUpIcon fontSize="small" />
            </MUIButton>
          </MUIGrid>
          <MUIGrid size={12}>
            <MUIButton
              variant="outlined"
              size="small"
              onClick={handleDown}
              sx={{ minWidth: "auto", aspectRatio: "1/1" }}
            >
              <MUIKeyboardArrowDownIcon fontSize="small" />
            </MUIButton>
          </MUIGrid>
          <MUIGrid size={12}>
            <MUIButton
              variant="outlined"
              size="small"
              onClick={handleBottom}
              sx={{ minWidth: "auto", aspectRatio: "1/1" }}
            >
              <MUIKeyboardDoubleArrowDownIcon fontSize="small" />
            </MUIButton>
          </MUIGrid>
        </MUIGrid>
      </MUIGrid>
    </MUIGrid>
  );
}
